module.exports = __webpack_public_path__ + "img/downloadprodukte.6450d6e5.svg";